export default __webpack_public_path__ + "static/media/jBRL.2315d9c0.svg";